<template >
  <div class="msp-gara-item">
    <v-card
    outlined
    class="gara-card"
    @click="clickItem"
    >

    <div class="corner-importanza">
      <img :src="'/img/coppa-b-w.svg#important-'+gara.importanza" class="img-importanza" alt="" />
    </div>

    <div class="gara-content">

      <div class="gara-row gara-row--sport">
        <i class="gara-icon-sport" :class="'msp-icon-sport-'+gara.sport_id" aria-hidden="true"></i>
        <span class="specialita">{{gara.sport_specialita_descrizione}}</span>
      </div>

      <p class="titolo">{{gara.descrizione}}</p>

      <div class="gara-esito" v-if="gara.risultato || gara.posizione_assoluta || gara.valutazione">
          <i class="msp-icon-time" /><span class="tempo" v-if="gara.risultato">{{formatoRisultato(gara.risultato)}}</span>
          <template  v-if="gara.posizione_assoluta">
              <i class="msp-icon-trophy-outlined" /><span class="posizione">{{gara.posizione_assoluta}}&ordf; assoluto</span>
          </template>
          <template v-if="gara.posizione_categoria">
              <i class="msp-icon-medal-outlined" /><span class="posizione" >{{gara.posizione_categoria}}&ordf; di categoria</span>
          </template>
      </div>

    </div>

<v-card-actions>

  <v-btn class="slot__note" text :class="classNote" small @click.prevent.stop="openChatCalendario(gara.calendario_id)">
      <i class="msp-icon icon-feedback note" :class="iconaCommenti"></i><span class='count' v-if="countCommenti">{{countCommenti}}</span>
  </v-btn>
<span class="rpe slot__rpe">
        <msp-valutazione v-if="gara.valutazione" :readonly="true" :init-value="gara.valutazione" :mono="true"></msp-valutazione>
       </span>


</v-card-actions>
</v-card>
</div>

</template>

<script>
import MSP from "@mixins/msp.js";
import mspValutazione from "./MspValutazione.vue";
export default {
  props: ['gara', 'day', 'week'],
  mixins: {
  },

  components: {
    mspValutazione,
},

  computed: {
      countCommentiNuovi: function () {
          return this.gara.chat_count_nuovi;
      },
      countCommenti: function () {
          return this.gara.chat_count_totale;
      },
      iconaCommenti: function () {
          let icona;
          if (this.countCommentiNuovi) {
              icona =  "msp-icon-note";
          } else if (this.countCommenti) {
              icona = "msp-icon-note-vuoto";
          } else {
              icona = "msp-icon-note-plus";
          }

          return icona
      },
      classNote: function () {
          if (this.countCommentiNuovi) {
              return "nuovi";
          }

          return "";
      },
  },

  data: function () {
    return {
      over: false,
      ghost: false,
      hasMenu: false,

      type: 'gara'

    }
  },
  watch: {

  },
  mounted: function() {
    //do something after mounting vue instance
    this.mounted();
  },
  methods: {
    openChatCalendario: function (calendario_id) {
      this.$emit("open-chat-calendario", calendario_id);
    },

    formatoRisultato: function(val) {
        return MSP.sec2hms(val);
  },

    clickItem: function(id) {
      this.$emit('click', id);
    },

    mounted: function() {
      this.$emit('mounted', this.gara);
    },

  }

}
</script>

<style lang="scss" >
.msp-gara-item {
  .gara-card {
    position: relative;
    overflow: hidden;
    --color: var(--h-gara-500);
    background: var(--h-gara-50);
  }

  .corner-importanza {
    position: absolute;
    top: 0;
    right: 0;
    width: 64px;
    height: 64px;
    background: var(--color);
    clip-path: polygon(100% 0, 0 0, 100% 100%);
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    padding: 4px 4px 0 0;
  }
  .img-importanza {
    width: 26px;
  }

  .gara-content {
    padding: 10px;
  }

  p {
    margin: 0;
  }

  .gara-row {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .gara-row--sport {
    margin-bottom: 4px;
    padding-right: 40px;
  }
  .gara-icon-sport {
    font-size: 1.4em;
  }
  .specialita {
    font-size: 0.9em;
  }

  .titolo {
    font-weight: bold;
    font-size: 1.2em;
    line-height: 1.2;
    margin-bottom: 4px;
  }

  .gara-esito {
      display: grid;
      grid-template-columns: auto 1fr;
      gap: 0 var(--spacing-1);
    font-size: 0.9em;
    flex-wrap: wrap;
  }

  --footer-icon-size: 20px;
  --footer-font-size: 12px;

    .msp-valutazione-mobile {
        padding: 0;
        .valutazione-testo {
            display: none;
        }
        .valutazione-icona {
        font-size: var(--footer-icon-size);
        }
    }
  .count {
      color: #000;
      padding: 2px;
  }
  .v-card__actions {
      display: grid;
      position: relative;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-template-areas: "rpe note percentuale bests";
      padding: 5px 10px;
      &, .v-btn {
      font-size: var(--footer-font-size);
      }
  }
  .slot {
      &__note {
          grid-area: note;
          justify-content: center;
          align-items: stretch;
          text-transform: none;
          --color: var(--col-grigio);
          &.nuovi i {
              --color: var(--col-msp);
          }
          i {
              font-size: var(--footer-icon-size);
              color: var(--color);
          }
      }
      &__rpe {
          grid-area: rpe;
          justify-content: center;
      }
  }
  .rpe {
      display: flex;
      align-items: center;
      justify-content: center;
  }
}
</style>
